import { render } from "./AddGlobalNotePage.vue?vue&type=template&id=60f2c3a8&ts=true"
import script from "./AddGlobalNotePage.vue?vue&type=script&lang=ts"
export * from "./AddGlobalNotePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__